const Setup = ()=>{
    return (
        <div className="projects-container">
            <h1>Configurazione</h1>
        </div>
    )
}

export default Setup